import { render } from "./ChangeOfferingForVolume.vue?vue&type=template&id=c10cf092&scoped=true"
import script from "./ChangeOfferingForVolume.vue?vue&type=script&lang=js"
export * from "./ChangeOfferingForVolume.vue?vue&type=script&lang=js"

import "./ChangeOfferingForVolume.vue?vue&type=style&index=0&id=c10cf092&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10cf092"]])

export default __exports__